import React from 'react'
import { ApiClientProviderV2 } from '@chilipiper/api-client/src/context'
import { getApiV2Config } from '@chilipiper/service/src/apiClientConfig'
import { syncStoredGuestId } from '@chilipiper/chat-components'
import { getPlaybookId, getTenantId, getWorkspaceId } from '../utils/embedCommunication'

const apiConfig = getApiV2Config()

const guestId = syncStoredGuestId(getWorkspaceId(), getTenantId(), getPlaybookId())

const apiConfigWithGuestId: typeof apiConfig = {
  ...apiConfig,
  customFetch: async (input, init = {}) => {
    init.headers = {
      ...init.headers,
      'x-caller-ref': `guest/${guestId}`,
    }
    const apiConfigFetchWithFallback = apiConfig.customFetch ?? fetch
    return apiConfigFetchWithFallback(input, init)
  },
}

export const ApiClientProvider = ({ children }: { children?: React.ReactNode }) => {
  return <ApiClientProviderV2 apiConfig={apiConfigWithGuestId}>{children}</ApiClientProviderV2>
}
